import { Component, Input, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { Entity } from '../../../../core/data-models/Entity';
import { ModuleName } from '../../../../shared/enums/ModuleName';
import { ThemeModule } from '../../../../shared/Theme/theme.module';
import { ChildrenAnimation } from '../../../../shared/animations/allAnimations';

/**
 * Extra Criteria Settings Component
 * 
 * Handles extra criteria management by wrapping the select-criteria component.
 * This is a container component that provides the header and controls
 * while delegating the criteria display/management to select-criteria.
 */
@Component({
    selector: 'extra-criteria-settings',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ThemeModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    templateUrl: './extra-criteria-settings.component.html',
    styleUrls: ['./extra-criteria-settings.component.scss'],
    animations: ChildrenAnimation
})
export class ExtraCriteriaSettingsComponent {
    readonly ModuleNames = ModuleName;

    @Input() selectedEntity!: Entity;
    @Input() language: string = 'EN';
    @Input() criteriaModal: boolean = false;

    @Output() criteriaModalChange = new EventEmitter<boolean>();
    @Output() updateMetrics = new EventEmitter<any>();

    onOpenCriteriaModal(): void {
        this.criteriaModal = true;
        this.criteriaModalChange.emit(true);
    }

    onUpdateEngagementMetrics(event: any): void {
        this.updateMetrics.emit(event);
    }
}
